<template>
    <van-config-provider :theme-vars="themeVars">
    <div class="van-hairline--surround">
         <van-cell-group inset border="false">
           <h3 style="padding-top: 1em;">体检项目建议</h3>
           <p class="textIndentation">我们建议您的项目注意涵盖以下相关检查（注：体检套餐由于多样性、时效性等情况，无法将套餐内细节一一说明，如果您对自己套餐选择有疑问，欢迎进一步来院沟通)
           </p>
         </van-cell-group>
         <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">(1)血压检查</van-divider>
            <p class="match"><van-notice-bar wrapable :scrollable="false"  color="#1989fa" left-icon="friends-o">
                一般体检套餐都会包含
                </van-notice-bar>
            </p>
      </van-cell-group>
      <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">(2)血脂检查</van-divider>
            <p class="match"><van-notice-bar wrapable :scrollable="false"  color="#1989fa" left-icon="fire-o">
                血脂四项检查，特别注意：<strong>需要涵盖高密度脂蛋白胆固醇、低密度脂蛋白胆固醇</strong>。有时套餐中血液检查不涵盖！！！
                </van-notice-bar>
            </p>
            <p class="match"><van-notice-bar wrapable :scrollable="false"  color="#1989fa" left-icon="fire-o">
                对于血脂异常人群，建议周期性监控血脂变化，一般以月为单位。
                </van-notice-bar>
            </p>
      </van-cell-group>
      <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">(3)胸部CT检查或CTA检查</van-divider>
            <p class="match"><van-notice-bar wrapable :scrollable="false"  color="#1989fa" left-icon="gem-o">
                对于风险较高人员，经我院体检医生确认，是否适合开展CTA检查？CTA等检查可以更为精准的确定冠心病等心脏疾病，但检查具有一定复杂性，需要和体检科医生沟通。
                </van-notice-bar>
            </p>
      </van-cell-group>
     </div>
   </van-config-provider>
   <van-button round color="linear-gradient(to right, #f67f34, #d55809)" size="large" to="about">了解早知心</van-button>
   <van-overlay :show="showOverlay" @click="showOverlay = false">
          <div class="wrapper" @click.stop>
              <div class="block">
                  <van-cell-group inset>
                      <van-notice-bar wrapable :scrollable="false" text="异常提醒" left-icon="info-o" />
                      <p class="textIndentation">
                          <van-notice-bar wrapable :scrollable="false" color="#1989fa" background="#ffffff">{{ bingingNotice
                          }}</van-notice-bar>
                      </p>
                      <van-button v-if="goToUserInfo" type="warning" block plain hairline to="bindingHosp">
                          开始绑定
                      </van-button>
                  </van-cell-group>
              </div>
          </div>
      </van-overlay>
  </template>
  <script>
  import { ref,toRefs,reactive, onMounted } from 'vue';
  import { postUserLog } from '../../api/userlog'
  import { useRouter } from 'vue-router';
  import { getCheckBinding } from '../../api/permission'
  import { getUserInfo} from '../../api/userinfo'
  export default {
   setup() {
  
     const themeVars = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     const kpian = reactive({
       cellGroupBackground: '#AAAAAA',
     });
     const kpianawait = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     const themeVars2 = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     let player = reactive(null)
     const router = useRouter(); 
     const goToUserInfo = ref(false);
     const bingingNotice = ref('');
     const showOverlay = ref(false);
     const state = reactive({
              userInfo: {
                  hospitalName: '',
                  area: '',
                  realName: '',
                  phone: '',
                  age: '',
                  gender: ''
              }
          });
     const ulog = reactive({
        UserLog: {
          path: '',
        }
      })
     onMounted(() => {
          ulog.UserLog.path = router.currentRoute.value.fullPath;
          console.log("当前页面路径=="+ulog.UserLog.path) 
          postUserLog(ulog.UserLog).then(() => {
           
          });
          /**登陆验证 */
          getCheckBinding().then((res1) => {
                  console.log(res1.data.code);
                  const binding = res1.data.code;
                  if (binding == 60002) {
                      showOverlay.value = true;
                      bingingNotice.value = "【绑定进度未完成】：我们会在1～3个工作日内完成";
                      goToUserInfo.value = true;
                  } else if (binding == 60000) {
                      showOverlay.value = true;
                      bingingNotice.value = "【绑定异常】：早知心，目前仅向我院体检机构服务的客户提供服务。您可以向我院体检机构获取【邀请码】";
                      goToUserInfo.value = true;
                  } else if (binding == 40000) {
                      showOverlay.value = true;
                      bingingNotice.value = "【登陆异常】：请您在微信端打开";
                  
                  } else {
                       getUserInfo().then((res3) => {
                          state.userInfo = res3.data.data;
                          console.log(res3.data.data);
                      })
                  }
              })
  
     })
     return {
       //fid,
       player,
       themeVars,
       kpian,
       kpianawait,
       themeVars2,
       goToUserInfo,
       bingingNotice,
       showOverlay,
       ...toRefs(state),
     }
   }
  }
  </script>
  <style scoped>
  @import url("//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css");
  #app {
   font-family: Avenir, Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   text-align: center;
   color: #2c3e50;
  }
  
  .textIndentation {
   text-align: left;
   text-indent: 2em;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1em;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
   line-height:30px;
  }
  
  .text2Indentation {
   text-align: left;
   text-indent: 2em;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1px;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
  }
  
  .match {
   text-align: left;
   text-indent: 1em;
   font-size: 14px;
  }
  
  .text3Indentation {
   text-align: left;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1em;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
  }
  </style>
  